<template>
  <div class="j2Demo">
    <nav-bar></nav-bar>
    <br><br>
        <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
          <div>
              <b-form-input v-model="secretCode"
                  type="text"
                  placeholder="Enter the secret code!!"></b-form-input>
              <p>Email shane.blaser@j2.com if you need the code</p>
  </div>
      </div>
      <div class="col-md-1"></div>
        </div>

    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion1 variant="info">Phone Number Lookup</b-btn>
      </b-card-header>
      <b-collapse id="accordion1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div class="row">
          <div class="col-md-6">
            <div>
              <b-form-input v-model="phoneNumberToLookUp"
                  type="text"
                  placeholder="Enter phone number"></b-form-input>
          </div>
          </div>
          <div class="col-md-4 float-left"><b-button  v-on:click="lookUpNumber" variant="success">Lookup</b-button></div>
          </div>
          <div class="row"><br></div>
          <div class="row">
            <div class="col-md-10">
    <b-form-textarea id="textarea1"
                     v-model="lookupResult"
                     placeholder="Lookup result will display here"
                     :rows="3"
                     :max-rows="100">
    </b-form-textarea>

            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion2 variant="info">Send Fax</b-btn>
      </b-card-header>
      <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div class="row">
          <div class="col-md-6">
            <div>
              <b-form-input v-model="phoneNumberFaxDestination"
                  type="text"
                  placeholder="Enter fax destination number"></b-form-input>
          </div>
          </div>
          <div class="col-md-4 float-left"><b-button  v-on:click="sendFax" variant="success">Send Fax</b-button></div>
          </div>
          <div class="row"><br></div>
          <div class="row">
            <div class="col-md-10">
            <b-form-textarea id="sendFaxTextArea"
                     v-model="sendFaxResult"
                     placeholder="Send Fax result will display here"
                     :rows="3"
                     :max-rows="100">
    </b-form-textarea>

            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion3 variant="info">Fax Status</b-btn>
      </b-card-header>
      <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div class="row">
          <div class="col-md-7">
            <div>
              <b-form-input v-model="faxIdForStatus"
                  type="text"
                  placeholder="Enter fax id you want status for"></b-form-input>
          </div>
          </div>
          <div class="col-md-3 float-left"><b-button  v-on:click="getFaxStatus" variant="success">Get Fax Status</b-button></div>
          </div>
          <div class="row"><br></div>
          <div class="row">
            <div class="col-md-10">
            <b-form-textarea id="sendFaxTextArea"
                     v-model="faxStatusResult"
                     placeholder="Fax status result will display here"
                     :rows="3"
                     :max-rows="100">
    </b-form-textarea>

            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
        <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion4 variant="info">Fax Picture</b-btn>
      </b-card-header>
      <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div class="row">
          <div class="col-md-7">
            <div>
              <b-form-input v-model="faxIdForStatus"
                  type="text"
                  placeholder="Enter fax id you want status for"></b-form-input>
          </div>
          </div>
          <div class="col-md-3 float-left"><b-button  v-on:click="takePicTwo" variant="success">Take Pic</b-button></div>
          </div>
          <div class="row"><input type="file" accept="image/*" id="file-input"><br>
          <div>
            <b-img id="faxImage" src="https://picsum.photos/1024/400/?image=41" fluid alt="Responsive image" />
          </div>
          </div>
          <div class="row">
            <div class="col-md-10">
            <b-form-textarea id="sendFaxTextArea"
                     v-model="faxPicStatusResult"
                     placeholder="Fax pic status result will display here"
                     :rows="3"
                     :max-rows="100">
    </b-form-textarea>
            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
      </div>
      <div class="col-md-1"></div>
    </div>
    </div>
</template>

<script>
import NavBar from '../components/NavBar'
import SessionData from '../components/SessionData'
const axios = require('axios')
const apiPath = 'https://shaneblaser.com/j2demo/'
export default {
  name: 'ShaneBlaserMessage',
  data () {
    return {
      msg: "Shane Blaser's home page",
      text: `
       some sample text
      `,
      lookupResult: '',
      phoneNumberToLookUp: '',
      secretCode: '',
      phoneNumberFaxDestination: '8057648278',
      sendFaxResult: '',
      faxStatusResult: '',
      faxIdForStatus: '',
      faxPicStatusResult: ''
    }
  },
  methods: {
    lookUpNumber: async function (event) {
      // console.log(event)
      this.lookupResult = ''
      const config = {
        method: 'get',
        url: apiPath + 'phoneNumberLookup/' + this.phoneNumberToLookUp,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'secretCode': this.secretCode
        }
      }
      let aNumberLookUp = await axios(config)
      console.log(aNumberLookUp.data)
      this.lookupResult = JSON.stringify(aNumberLookUp.data, undefined, 4)
    },
    takePicTwo: async function () {
      function readFile (file) {
        var reader = new FileReader()
        reader.onload = readSuccess
        function readSuccess (evt) {
          document.getElementById('faxImage').src = evt.target.result
        };
        reader.readAsDataURL(file)
      }

      document.getElementById('cameraInput').onchange = function (e) {
        readFile(e.srcElement.files[0])
      }
    },
    takePic: async function () {
      console.log('take pic')
      navigator.mediaDevices.getUserMedia({video: true})
        .then(gotMedia)
        .catch(error => console.error('getUserMedia() error:', error))

      function gotMedia (mediaStream) {
        const mediaStreamTrack = mediaStream.getVideoTracks()[0]
        const imageCapture = new ImageCapture(mediaStreamTrack)
        console.log(imageCapture)
        // this.addToFaxPicStatus(imageCapture)
        const img = document.getElementById('faxImage')
        console.log('image object: ', img)
        // ...
        imageCapture.takePhoto()
          .then(blob => {
            img.src = URL.createObjectURL(blob)
            img.onload = () => { URL.revokeObjectURL(this.src) }
          })
          .catch(error => console.error('takePhoto() error:', error))
      }
    },
    sendFax: async function (event) {
      // console.log(event)
      this.sendFaxResult = ''
      const config = {
        method: 'get',
        url: apiPath + 'fax/sendFax/' + this.phoneNumberFaxDestination,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'secretCode': this.secretCode
        }
      }
      let sendFaxResult = await axios(config)
      console.log(sendFaxResult)
      this.sendFaxResult = JSON.stringify(sendFaxResult.data, undefined, 4)
      this.faxIdForStatus = sendFaxResult.data.sid
    },
    addToFaxPicStatus: function (aString) {
      this.faxPicStatusResult += aString
    },
    getFaxStatus: async function (event) {
      // console.log(event)
      this.sendFaxResult = ''
      const config = {
        method: 'get',
        url: apiPath + 'fax/getStatus/' + this.faxIdForStatus,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'secretCode': this.secretCode
        }
      }
      let faxStatus = await axios(config)
      console.log(faxStatus)
      this.faxStatusResult = JSON.stringify(faxStatus.data, undefined, 4)
    }
  },
  components: {
    NavBar,
    SessionData
  },
  mounted () {
    const fileInput = document.getElementById('file-input')

    fileInput.addEventListener('change', (e) => {
      console.log(e)
      const img = document.getElementById('faxImage')
      img.src = URL.createObjectURL(e.target.files[0])
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.btn-info {
    color: #fff;
    background-color: #7011b5;
    border-color: #400752;
}

.btn-success {
    color: #fff;
    background-color: #7011b5;
    border-color: #400752;
}
</style>



// WEBPACK FOOTER //
// src/components/j2Demo.vue